export default "__VITE_ASSET__a891ee3a__"